const tableHeader = [
  'Nome do Cliente',
  'Localização',
  'Vendedor',
  'Criação',
  'Validade',
  'Proposta',
  'Orçamento',
  'Status',
  'Duplicar',
  'Baixar',
];

const Tablecadastro = [
  {
    id: 1,
    title: 'Nome',
    type: 'text',
    placeholder: 'Informe o nome do Orçamento',
  },
  { id: 2, title: 'Frete', type: 'number', placeholder: 'Informe o Frete' },
  {
    id: 3,
    title: 'Prazo Final',
    type: 'number',
    placeholder: 'Informe o Prazo',
  },
  { id: 4, title: 'Validade', type: 'date', placeholder: 'Validade' },
  { id: 5, title: 'Status', type: 'text', placeholder: 'Informe o status' },
  {
    id: 6,
    title: 'Tipo de Consumidor',
    type: 'text',
    placeholder: 'Informe o tipo de consumidor',
  },
  { id: 7, title: 'Cliente', type: 'text', placeholder: 'Selecione o Cliente' },
  {
    id: 8,
    title: 'Usuário',
    type: 'text',
    placeholder: 'Selecione o Vendedor',
  },
  {
    id: 9,
    title: 'Pagamento',
    type: 'text',
    placeholder: 'Selecione o pagamento',
  },
  {
    id: 2,
    title: 'Permissões',
    type: 'text',
    placeholder: 'Informe a permissão',
  },

  {
    id: 4,
    title: 'Localização',
    type: 'text',
    placeholder: 'Informe a localização ...',
  },
  {
    id: 5,
    title: 'Validade',
    type: 'text',
    placeholder: 'Informe a validade ...',
  },
  { id: 6, title: 'Orçamento', type: 'text', placeholder: '' },
];

const title = 'Cadastro de Orçamento';

export const cadastro = {
  title: title,
  cadastro: Tablecadastro,
};

export const table = {
  header: tableHeader,
  type: 'orcamento',
};
